/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumIndex.vue?vue&type=template&id=53b3ee7c&scoped=true"
import script from "./ForumIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumIndex.vue?vue&type=style&index=0&id=53b3ee7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3ee7c",
  null
  
)

export default component.exports